import React, { Component } from 'react';
import {checkToken, getMenuTree, toggleTenant,getQueryVariable} from "../../requist";
import {message, Spin} from 'antd';
class USFLogin extends Component{
    getMenuList() {
        getMenuTree().then(res=>{
            const {data} = res;
            console.log(data)
            if(data && data.length){
                data.forEach(item=>{
                    if(item.sysmenu === 0){
                        localStorage.setItem('menuList',JSON.stringify(item.childMenuList));
                        window.localStorage.setItem('menuList',JSON.stringify(item.childMenuList));
                    }
                })
            }
        }).finally(()=>{
            window.location.href='/disputeHome'
        })
    }
    componentDidMount() {
        window.localStorage.setItem('userType','internal');
        let token = getQueryVariable('token');
        window.localStorage.removeItem('userToken');
        window.localStorage.removeItem('lenovoid');
        window.localStorage.removeItem('sst');
        window.localStorage.removeItem('userInfo');
        window.localStorage.setItem('userToken',token);
        window.localStorage.removeItem('menuList');
        if(token){
            toggleTenant().then(res=>{
                const {code}=res;
                if(code===0){
                    checkToken(token).then(res=>{
                        const {data} = res;
                        let userInfo = {
                            requestorEmail: data.email,
                            requestorID: data.username,
                            requestorPhoneNo: data.callPhone,
                        }
                        window.localStorage.setItem('userId', data.username);
                        localStorage.setItem('userInfo',JSON.stringify(userInfo));
                    }).then(()=>{
                        this.getMenuList();
                    })
                }
            })
        } else {
            message.warn('Auth failed, please relogin', 1.5)
            .then(()=>{
                window.location.href = '/disputeHome'
            })
            
        }
    }
    render() {
        return  <div className="loginSpin">
        <Spin />
      </div>;
    }
}

export default USFLogin;